import { authHeaders, storeOrderToken } from '../../api';

import { API_URL } from '../../api';

// localStorage ne doit jamais faire planter le formulaire (données corrompues)
export const readLS = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
};

export const writeLS = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false; // quota plein : on continue quand même, le backend a la commande
  }
};

const safe = (v) => String(v ?? '').slice(0, 500);

export const buildOrderMessage = (orderData) => ({
  id: `order-${orderData.id}-details`,
  sender: 'system',
  text: `📋 Détails de la commande #${safe(orderData.id) || 'N/A'}:
${orderData.type === 'buy' ? '🛒 ACHAT' : '💰 VENTE'} de ${safe(orderData.quantity)}M Kamas
🎮 Serveur: ${safe(orderData.server)} (${safe(orderData.category)})
👤 Personnage: ${safe(orderData.character)}
💰 Prix: ${Number(orderData.totalPrice || 0).toFixed(2)} DH (${Number(orderData.pricePerM || 0).toFixed(2)} DH/M)
📧 Email: ${safe(orderData.email)}
${orderData.phone ? `📱 Téléphone: ${safe(orderData.phone)}` : ''}
${orderData.type === 'sell' ? `🏦 Banque: ${safe(orderData.bankName)}\n👤 Titulaire: ${safe(orderData.accountHolder)}\n💳 RIB: ${safe(orderData.accountNumber)}` : ''}`.trim(),
  timestamp: new Date().toISOString(),
  status: 'read',
});

// Envoie la commande au backend. Renvoie l'orderToken si le serveur en fournit un.
export async function createOrderOnServer(dbOrderData) {
  const response = await fetch(`${API_URL}/api/create_order`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(dbOrderData),
  });
  const result = await response.json();
  if (!response.ok) return { ok: false, error: result.error || 'Erreur serveur' };
  return { ok: true, orderToken: result.orderToken || null };
}

// Persiste la commande + son message de chat côté navigateur (fallback admin/historique)
export function saveOrderLocally(orderData, dbOrderData) {
  if (orderData.orderToken) storeOrderToken(orderData.id, orderData.orderToken);

  const adminOrders = readLS('admin_orders', []);
  adminOrders.push(dbOrderData);
  writeLS('admin_orders', adminOrders);

  const orders = readLS('orders', []);
  orders.push(orderData);
  writeLS('orders', orders);

  writeLS('completedOrder', orderData);

  const chatHistory = readLS('chatHistory', []);
  chatHistory.push({
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    orderData,
    messages: [buildOrderMessage(orderData)],
    createdAt: new Date().toISOString(),
    status: 'unread',
  });
  writeLS('chatHistory', chatHistory);
}
